import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
});

const tableSessionsBasePath = '/table-sessions';

//API to manage the table access requests (sessions) created from the public ecommerce flow
export class TableSessionsFetchAPI {
    //Function to get the pending/approved/etc sessions of a branchoffice
    static async getPendingSessions({ branchoffice_code, status, page, limit }, token) {
        const params = new URLSearchParams();
        if (branchoffice_code) params.append('branchoffice_code', branchoffice_code);
        if (status) params.append('status', status);
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);

        const res = await server(`${tableSessionsBasePath}/pending?${params.toString()}`, {
            method: 'get',
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to get the active session of a table
    static async getActiveSessionByTable(table_id, token) {
        const res = await server(`${tableSessionsBasePath}/table/${table_id}/active`, {
            method: 'get',
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to approve a table session request
    static async approveSession(session_uuid, data, token) {
        const res = await server(`${tableSessionsBasePath}/${session_uuid}/approve`, {
            method: 'post',
            headers: { 'x-access-token': token },
            data,
        });
        return res;
    }

    //Function to reject a table session request
    static async rejectSession(session_uuid, data, token) {
        const res = await server(`${tableSessionsBasePath}/${session_uuid}/reject`, {
            method: 'post',
            headers: { 'x-access-token': token },
            data,
        });
        return res;
    }

    //Function to close an active table session
    static async closeSession(session_uuid, data, token) {
        const res = await server(`${tableSessionsBasePath}/${session_uuid}/close`, {
            method: 'post',
            headers: { 'x-access-token': token },
            data,
        });
        return res;
    }

    // The backend creates a public code when this table does not have one yet.
    static async getTableQr(table_id, token) {
        const res = await server(`${tableSessionsBasePath}/admin/table/${table_id}/qr`, {
            method: 'get',
            headers: { 'x-access-token': token },
        });
        return res;
    }
}
